import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../../shared/Link/Link';
// import * as Sentry from '@sentry/react';

import { loadOrder } from '../../../../redux/modules/singleOrder';
import { loadOrders } from '../../../../redux/modules/orders';
import { emptyCart, loadCart } from '../../../../redux/modules/cart';
import { resetCheckout } from '../../../../redux/modules/checkout';

import Price from '../../../shared/Price/Price';
import {
  purchase,
  pushRemarketingEvent,
} from '../../../shared/lib/gaEnhancedEcommerce';

import { MdCheck, MdSentimentVeryDissatisfied } from 'react-icons/md';
import './CheckoutResult.scss';
import { ga4Purchase } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxPurchase } from '../../../shared/lib/farmakomMetrics';
import {
  gAdsConversion,
  gAdsPurchase,
} from '../../../shared/lib/gAdsEnhancedEcommerce';
import { getSHA256Hash } from '../../../../utils/sha256';
import { criteoTrackTransaction } from '../../../shared/lib/criteo';
import api from '../../../../api';
import axios from 'axios';
import { gtmToGa4Purchase } from '../../../shared/lib/gtmEnhancedEcommerce';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';
import IubendaCookieSolution from '../../../../utils/iubenda';

// RIMOSSO PERCHÉ SE L'UTENTE FA UN ORDINE ALLORA HA ACCETTATO LA PRIVACY
// import IubendaCookieSolution from '../../../../utils/iubenda';

const MOVO_COLOR = '#01C39A';

class CheckoutSuccess extends Component {
  componentDidMount() {
    // const iubenda = new IubendaCookieSolution(
    //   this.props.hasIubendaCookieSolution
    // );

    // Sentry.captureMessage(
    //   `CheckoutSuccess - storeId: ${this.props.storeId} - orderId: ${this.props
    //     .location.query.orderId || this.props.checkout.orderId}`,
    //   'info'
    // );

    this.props.loadOrder(
      this.props.location.query.orderId || this.props.checkout.orderId,
      this.props.location.query.userEmail
    );

    // JQUERY
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://code.jquery.com/jquery-1.4.min.js';
    document.head.appendChild(script1);

    // TROVAPREZZI
    if (!this.props.hasTrovaprezziTrustedProgram) {
      // Lo facciamo solo se non è attivo il trusted perchè se hanno
      // il trusted program è già importato nell'head del sito
      const script2 = document.createElement('script');
      script2.src =
        'https://tracking.trovaprezzi.it/javascripts/tracking-vanilla.min.js';

      // iubenda.proceedIfHasConsent(() =>
      setTimeout(() => {
        document.head.appendChild(script2);
      }, 100);
      // );
    }

    // Reset cart
    if (!this.props.location.query.pay_later) {
      this.props.emptyCart();
      this.props.loadCart();
    }
    // Reset coupon
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('coupon');
    }
    // Reset checkout
    this.props.resetCheckout();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.order !== prevProps.order &&
      this.props.order.items &&
      this.props.order.items.length > 0
    ) {
      this.trackOrder();
    }
  }

  trackOrder() {
    const { order, trovaprezziId } = this.props;

    // SETUP IUBENDA
    // const iubenda = new IubendaCookieSolution(hasIubendaCookieSolution);

    /////////////////////////////////
    // GOOGLE ANALYTICS: TRANSACTION
    const productsGA = order.items.map(p => ({
      id: p.minsanCode || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));

    const transactionGA = {
      id: order.id,
      revenue: order.grandTotal,
      tax: order.totalTax,
      shipping: order.totalShipping,
      coupon: order.coupon.name,
    };

    // GTM PURCHASE
    if (this.props.hasGoogleTagManager) {
      gtmToGa4Purchase(
        {
          ...order,
          id: order.id,
          revenue: order.grandTotal,
          tax: order.totalTax,
          shipping: order.totalShipping,
          coupon: order.coupon.name,
          items: order.items,
        },
        {
          glsShipping: this.props.glsShipping,
          costiSpedizione: this.props.costiSpedizione,
        }
      );
    }

    // GA4 PURCHASE
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4Purchase({
        id: order.id,
        revenue: order.grandTotal,
        tax: order.totalTax,
        shipping: order.totalShipping,
        coupon: order.coupon.name,
        items: order.items,
      });
    }

    // GADS Conversion
    if (
      !!this.props.hasGoogleAdsTag &&
      !!this.props.gAdsTrackingId &&
      !!this.props.gAdsGoalId
    ) {
      // Conversions for Ads
      gAdsConversion(
        {
          ...order,
          id: order.id,
          revenue: order.grandTotal,
        },
        this.props.gAdsTrackingId,
        this.props.gAdsGoalId
      );
      // Purchase for dynamic pricing
      gAdsPurchase(
        {
          ...order,
          id: order.id,
          revenue: order.grandTotal,
          tax: order.totalTax,
          shipping: order.totalShipping,
          coupon: order.coupon.name,
          items: order.items,
        },
        this.props.gAdsTrackingId,
        this.props.gAdsGoalId,
        {
          glsShipping: this.props.glsShipping,
          costiSpedizione: this.props.costiSpedizione,
        }
      );
    }

    // FKMX PURCHASE
    if (this.props.hasFarmakomMetrics) {
      fkmxPurchase({
        id: order.id,
        revenue: order.grandTotal,
        tax: order.totalTax,
        shipping: order.totalShipping,
        coupon: order.coupon.name,
        items: order.items.map(item => {
          const categoryName = item.parentCategoryName;
          const subcategoryName = item.categoryName;
          const brand = item.brandStandard;
          return {
            ...item,
            brand,
            categoryName,
            subcategoryName,
          };
        }),
      });
    }

    // SEND EVENT
    if (this.props.advancedGa) {
      // Sentry.withScope(scope => {
      //   scope.setExtra('transactionGA', transactionGA);
      //   scope.setExtra('productsGA', productsGA);
      //   Sentry.captureMessage(
      //     `CheckoutSuccess - storeId: ${this.props.storeId} - orderId: ${order.id}`,
      //     'info'
      //   );
      // });

      purchase(productsGA, transactionGA);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('purchase', order.items);
    }

    /////////////////////////////
    // TROVAPREZZI
    if (!!trovaprezziId) {
      if (!!this.props.hasIubendaCookieSolution) {
        this.renderTrovaprezziIubendaScript();
      } else {
        this.renderTrovaprezziScript();
      }
    }

    /////////////////////////////
    // TRANSACTIONALE
    if (!!window._trx) {
      const transactionaleItems = order.items.map(item => {
        return {
          id: item.productId,
          price: item.price,
          quantity: item.quantity,
        };
      });

      // iubenda.proceedIfHasConsent(() => {
      window._trx.push({
        event: 'trackTransaction',
        transaction: {
          id: order.id,
          total: order.grandTotal,
        },
        items: transactionaleItems,
        address: {
          address: order.shipping.address1 || '',
          address2: order.shipping.address2 || '',
          city: order.shipping.city || '',
          postalCode: order.shipping.zipcode || '',
          country: order.shipping.country || 'IT',
        },
        customer: {
          email: order.userEmail,
          optin: false, // Default to false
        },
        touchpointType: 'auto',
      });
      // });
    }

    ///////////////////////////
    // CRITEO
    if (this.props.hasCriteo) {
      this.renderCriteoTag();
    }

    ///////////////////////////////
    // KELKOO
    if (this.props.hasKelkoo && this.props.kelkooMerchantId) {
      // iubenda.proceedIfHasConsent(() => this.renderKelkooScript());
      this.renderKelkooScript();
    }

    //////////////////////////////
    // TRADETRACKER
    if (this.props.hasTradeTracker) {
      // iubenda.proceedIfHasConsent(() => this.renderTradeTrackerScript());
      this.renderTradeTrackerScript();
    }

    //////////////////////////////
    // TRADEDOUBLER
    if (this.props.hasTradedoubler) {
      // iubenda.proceedIfHasConsent(() => this.renderTradeTrackerScript());
      this.renderTradedoublerScript();
    }
  }

  renderTrovaprezziScript = () => {
    const { order, email, trovaprezziId } = this.props;
    const userEmail = order.userEmail;

    const script = document.createElement('script');

    const orderItems = order.items.reduce((acc, item) => {
      return (
        acc +
        `window._tpt.push({ event: 'addItem', sku: '${item.productId}', product_name: '${item.name}' });`
      );
    }, '');

    script.innerHTML = `window._tpt = window._tpt || [];
      ${
        !!userEmail || !!email
          ? `window._tpt.push({ event: 'setEmail', email: '${userEmail ||
              email}' });`
          : ''
      }
      ${orderItems}
      window._tpt.push({ event: 'setAccount', id: '${trovaprezziId}' });
      window._tpt.push({ event: 'setOrderId', order_id: '${order.id}' });
      window._tpt.push({ event: 'setAmount', amount: '${order.grandTotal}' });
      window._tpt.push({ event: 'orderSubmit'});`;

    setTimeout(() => {
      document.body.appendChild(script);
    }, 200);
  };

  renderTrovaprezziIubendaScript = () => {
    const { order, email, trovaprezziId } = this.props;
    const userEmail = order.userEmail;

    // Purpose 1 means that the script is always loaded
    const scriptPurpose5 = document.createElement('script');
    const orderItems = order.items.reduce((acc, item) => {
      return (
        acc +
        `window._tpt.push({ event: 'addItem', sku: '${item.productId}', product_name: '${item.name}' });`
      );
    }, '');
    scriptPurpose5.innerHTML = `window._tpt = window._tpt || [];
      ${
        !!userEmail || !!email
          ? `window._tpt.push({ event: 'setEmail', email: '${userEmail ||
              email}' });`
          : ''
      }
      ${orderItems};`;

    const scriptPurpose1 = document.createElement('script');
    scriptPurpose1.innerHTML = `window._tpt = window._tpt || [];
      window._tpt.push({ event: 'setAccount', id: '${trovaprezziId}' });
      window._tpt.push({ event: 'setOrderId', order_id: '${order.id}' });
      window._tpt.push({ event: 'setAmount', amount: '${order.grandTotal}' });
      window._tpt.push({ event: 'orderSubmit'});`;

    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    setTimeout(() => {
      iubenda.proceedIfHasConsent(() => {
        document.head.appendChild(scriptPurpose5);
      });
      setTimeout(() => {
        document.head.appendChild(scriptPurpose1);
      }, 500);
    }, 200);
  };

  renderKelkooScript = () => {
    const { order } = this.props;

    if (order) {
      const scriptKelkoo = document.createElement('script');

      scriptKelkoo.innerHTML = `
        _kkstrack = {
          merchantInfo : [{ country:"it", merchantId:"${this.props.kelkooMerchantId}" }],
          orderValue: ${order.grandTotal},
          orderId: ${order.id}
        };
        (function() {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://s.kk-resources.com/ks.js';
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        })();
      `;

      setTimeout(() => {
        document.body.appendChild(scriptKelkoo);
      }, 300);
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Basket/Cart Tag -->
    const { order } = this.props;
    if (order) {
      const email = (order && order.userEmail) || '';
      const zipcode = (order && order.shipping && order.shipping.zipcode) || '';

      criteoTrackTransaction(
        this.props.criteoAccountId,
        {
          email,
          zipcode,
        },
        order.items,
        order.id
      );
    }
    // <!-- END Criteo Basket/Cart Tag -->
  };

  renderTradeTrackerScript = () => {
    const { order, tradeTracker } = this.props;
    if (order && tradeTracker.campaignId && tradeTracker.productId) {
      const trade_tracker_script_1 = document.createElement('script');
      trade_tracker_script_1.id = 'trade_tracker_script_1';
      trade_tracker_script_1.type = 'text/javascript';
      trade_tracker_script_1.innerHTML = `
        var ttConversionOptions = ttConversionOptions || [];
        ttConversionOptions.push({
          type: 'sales',
          campaignID: '${tradeTracker.campaignId}',
          productID: '${tradeTracker.productId}',
          transactionID: '${order.id}',
          transactionAmount: '${this.getTotalWithoutTaxAndShipment()}',
          quantity: '1',
          descrMerchant: '',
          descrAffiliate: '',
          vc: '',
          currency: ''
        });
      `;
      const trade_tracker_script_2 = document.createElement('script');
      trade_tracker_script_2.id = 'trade_tracker_script_2';
      trade_tracker_script_2.type = 'text/javascript';
      trade_tracker_script_2.innerHTML = `
        // No editing needed below this line.
        (function(ttConversionOptions) {
          var campaignID = 'campaignID' in ttConversionOptions ? ttConversionOptions.campaignID : ('length' in ttConversionOptions && ttConversionOptions.length ? ttConversionOptions[0].campaignID : null);
          var tt = document.createElement('script'); tt.type = 'text/javascript'; tt.async = true; tt.src = '//tm.tradetracker.net/conversion?s=' + encodeURIComponent(campaignID) + '&t=m';
          var s = document.getElementsByTagName('script'); s = s[s.length - 1]; s.parentNode.insertBefore(tt, s);
        })(ttConversionOptions);
      `;
      setTimeout(() => {
        document.body.appendChild(trade_tracker_script_1);
        document.body.appendChild(trade_tracker_script_2);
      }, 200);
    }
  };

  renderTradedoublerScript = async () => {
    const { order, tradedoubler, storeId } = this.props;

    let ordersCount = 0;
    try {
      const { endpoint, headers, method } = api.getOrdersCount();
      const orders = await axios({
        url: endpoint,
        method,
        headers: {
          ...headers,
          storeid: storeId,
        },
      });
      ordersCount = orders.data;
    } catch (error) {
      console.error('error getting orders count: ', error);
    }

    if (!!order && !!tradedoubler.organization) {
      let eventCode = '';

      if (!!order.userId) {
        if (ordersCount > 1) {
          eventCode = tradedoubler.eventPurchaseRecurringUser;
        } else {
          eventCode = tradedoubler.eventPurchaseNewUser;
        }
      } else {
        eventCode = tradedoubler.eventPurchaseGuest;
      }

      if (!eventCode) {
        return;
      }

      let orderValue = this.getTotalWithoutTaxAndShipment();

      let couponDiscount = this.getTotalCoupons();

      orderValue = orderValue - couponDiscount;

      const tradedoubler_iframe = document.createElement('iframe');
      tradedoubler_iframe.id = 'tradedoubler_iframe';
      tradedoubler_iframe.src = `https://tbs.tradedoubler.com/report?organization=${tradedoubler.organization}&event=${eventCode}&ordernumber=${order.id}&orderValue=${orderValue}&currency=EUR&type=iframe`;
      tradedoubler_iframe.width = '1';
      tradedoubler_iframe.height = '1';

      const tradedoubler_img = document.createElement('img');
      tradedoubler_img.id = 'tradedoubler_img';
      tradedoubler_img.src = `https://img-statics.com/report?o=${tradedoubler.organization}&e=${eventCode}&ordnum=${order.id}&ordval=${orderValue}&curr=EUR`;
      tradedoubler_img.alt = '';
      tradedoubler_img.style = 'width:0;height:0;border:none';

      setTimeout(() => {
        const tradedoubleContainer = document.getElementById(
          'tradedoubler_container'
        );
        tradedoubleContainer.appendChild(tradedoubler_iframe);
        tradedoubleContainer.appendChild(tradedoubler_img);
      }, 200);
    }
  };

  getTotalWithoutTaxAndShipment = () => {
    const total = this.props.order.items.reduce((acc, curr) => {
      return (
        acc +
        ((curr.price * 100) / (100 + (curr.taxRate || 0))) *
          (curr.quantity || 1)
      );
    }, 0);
    return Math.round((total + Number.EPSILON) * 100) / 100;
  };

  getTotalItems = () => {
    const total = this.props.order.items.reduce(
      (acc, curr) => acc + curr.price * (curr.quantity || 1),
      0
    );
    return Math.round((total + Number.EPSILON) * 100) / 100;
  };

  getTotalCoupons = () => {
    const total = this.props.order.items.reduce(
      (acc, curr) => acc + curr.couponDiscount,
      0
    );
    return Math.round((total + Number.EPSILON) * 100) / 100;
  };

  renderItem = () => {
    return this.props.order.items.map((item, i) => (
      <div
        key={i}
        style={{
          width: '100%',
          border: 'solid 1px #CCC',
          marginBottom: '1rem',
          padding: '1rem',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '.8fr 2fr .4fr .4fr .4fr',
            gap: '0px 0px',
            alignItems: 'center',
          }}
        >
          <div style={{ width: '10%' }}>
            <ImageDispatcher style={{ maxWidth: '100px' }} src={item.image} />
          </div>
          <div
            style={{
              textAlign: 'left',
              fontSize: '14px',
            }}
          >
            <b>{item.name}</b>
          </div>
          <div style={{ display: 'flex', flexFlow: 'column' }}>
            <b
              style={{
                fontSize: 12,
                color: 'grey',
                textDecoration: 'line-through',
              }}
            >
              {item.listPrice}€
            </b>
            <b style={{}}>{item.price}€</b>
          </div>
          <b style={{}}>{item.quantity}</b>
          <b style={{}}>{item.price * item.quantity}€</b>
        </div>
      </div>
    ));
  };

  itemsDetails = () => {
    const { siteName, primaryColor } = this.props;
    return (
      <div>
        <div
          className="cta-container"
          style={{ display: 'flex', justifyContent: 'center', gap: 8 }}
        >
          <Link to="/" className="btn btn-primary">
            Vai alla homepage
          </Link>
          <Link to="/prodotti-in-offerta" className="btn btn-outline">
            Vai ai prodotti
          </Link>
        </div>
        {this.props.order.isGreenPackage && (
          <div>
            <div className="movo-thank-you-text">
              <span> Grazie per aver contribuito ad evitare gli sprechi,</span>
              <span style={{ color: MOVO_COLOR }}>
                {' '}
                hai selezionato il green packaging di {siteName}!
              </span>
              <span>
                {' '}
                Segui le istruzioni qui sotto per riutilizzare il pack della
                spedizione.
              </span>
            </div>
            <div className="movo-thank-you-text">
              <span>
                {' '}
                Se il tuo ordine eccede il massimo di capienza delle nostre box
                personalizzate
              </span>
              <span style={{ color: MOVO_COLOR }}>
                {' '}
                non ti preoccupare, {siteName}
              </span>
              <span>
                {' '}
                ti consegnerà i tuoi prodotti con un packaging di materiale
                riciclato e utilizzerà il tuo contributo
              </span>
              <span style={{ color: MOVO_COLOR }}>
                {' '}
                per operazioni di riciclo.
              </span>
              <br />
              <span> Il nostro ambiente sarà ugualmente protetto</span>
            </div>

            <div className="movo-card-container">
              <div className="movo-card">
                <p
                  style={{
                    fontSize: '41px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    alignSelf: 'flex-start',
                  }}
                >
                  1
                </p>
                <p
                  style={{
                    fontSize: '18px',
                    color: 'black',
                    textAlign: 'left',
                  }}
                >
                  Ripiega la scatola seguendo le istruzioni che trovi al suo
                  interno.
                </p>
                <ImageDispatcher
                  style={{ width: '132px', height: '132px' }}
                  src="/static/images/movo_bag.png"
                />
              </div>

              <div className="movo-card">
                <p
                  style={{
                    fontSize: '41px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    alignSelf: 'flex-start',
                  }}
                >
                  2
                </p>
                <p
                  style={{
                    fontSize: '18px',
                    color: 'black',
                    textAlign: 'left',
                  }}
                >
                  Porta la confezione piegata in qualsiasi casella postale senza
                  costi aggiuntivi.
                </p>
                <ImageDispatcher
                  style={{ width: '132px', height: '132px' }}
                  src="/static/images/movo_post.png"
                />
              </div>

              <div className="movo-card" style={{ marginBottom: 'unset' }}>
                <p
                  style={{
                    fontSize: '41px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    alignSelf: 'flex-start',
                  }}
                >
                  3
                </p>
                <p
                  style={{
                    fontSize: '18px',
                    color: 'black',
                    textAlign: 'left',
                  }}
                >
                  Movo ritira, pulisce e riconsegna il pack per poterlo
                  riutilizzare.
                </p>
                <ImageDispatcher
                  style={{ width: '132px', height: '132px' }}
                  src="/static/images/movo_truck.png"
                />
              </div>
            </div>
          </div>
        )}

        {this.props.order.payment.typeName &&
          this.props.order.payment.typeName.toLowerCase() ===
            'contrassegno' && (
            <div className="paymentInstruction grey">
              <p style={{ fontSize: '18px' }}>
                Ricorda che dovrai pagare{' '}
                <Price amount={this.props.order.grandTotal} /> in contrassegno
                al corriere.
              </p>
            </div>
          )}

        {this.props.order.payment.typeName &&
          this.props.order.payment.typeName.toLowerCase() === 'bonifico' && (
            <div className="paymentInstruction grey">
              <p style={{ fontSize: '18px' }}>
                Restiamo in attesa del bonifico bancario di{' '}
                <b style={{ fontSize: '18px' }}>
                  <Price amount={this.props.order.grandTotal} />
                </b>{' '}
                su:
              </p>
              <p style={{ fontSize: '18px' }}>
                {this.props.bankName} - IBAN:{' '}
                <b style={{ fontSize: '18px' }}>{this.props.bankAccount}</b>,
                indicando come causale "P{this.props.order.id}"
              </p>
            </div>
          )}

        <div
          className="table-order"
          style={{
            backgroundColor: 'white',
            width: '60rem',
            marginTop: '2rem',
            padding: '3rem',
          }}
        >
          <h4 style={{ textAlign: 'left' }}>
            <b>Dettagli ordine</b>
          </h4>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <p>Prodotto</p>
            </div>
            <div style={{ display: 'flex', maxWidth: '15rem' }}>
              <p style={{ marginRight: '2rem' }}>Prezzo</p>
              <p style={{ marginRight: '2rem' }}>Quantità</p>
              <p style={{ marginRight: '2rem' }}>Subtotale</p>
            </div>
          </div>
          <hr style={{ borderColor: '#CCC' }}></hr>
          <div style={{ width: '100%' }}>{this.renderItem()}</div>

          <hr style={{ borderColor: '#CCC' }}></hr>

          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
            }}
          >
            <div
              style={{ textAlign: 'left', marginRight: '8rem', color: '#CCC' }}
            >
              <div>Subtotale</div>
              <div>Spedizione</div>
              <div>Coupon</div>
              <div>
                <b style={{ fontSize: '19px', color: 'black' }}>Totale</b>
              </div>
            </div>
            <div style={{ textAlign: 'right', color: '#CCC' }}>
              <div> €{this.getTotalItems()}</div>
              <div> €{this.props.order.totalShipping} </div>
              <div> - €{this.getTotalCoupons()}</div>
              <div>
                <b style={{ fontSize: '19px', color: 'black' }}>
                  €{this.props.order.grandTotal}
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      bankName,
      bankAccount,
      order,
      primaryColor,
      uiVariantButton,
      hasTradeTracker,
      tradeTracker,
    } = this.props;

    return (
      <div className="checkout-result checkout-success">
        {/* TRANSACTIONALE */}
        <div id="tr_touchpoint_container" />

        {/* TRADETRACKER - FIXME: credo che funzioni male, sarebbe da caricare solo dopo che viene caricato order */}
        {hasTradeTracker && tradeTracker.campaignId && tradeTracker.productId && (
          <noscript>
            <ImageDispatcher
              src={`//ts.tradetracker.net/?cid=${
                tradeTracker.campaignId
              }&amp;pid=${tradeTracker.productId}&amp;tid=${
                order.id
              }&amp;tam=${this.getTotalWithoutTaxAndShipment()}&amp;data=&amp;qty=1&amp;descrMerchant=&amp;descrAffiliate=&amp;event=sales&amp;currency=EUR&amp;vc=`}
              alt=""
            />
          </noscript>
        )}

        {/* TRADEDOUBLER */}
        <div id="tradedoubler_container" />

        <div
          className="check"
          style={{
            color: !!this.props.order.isGreenPackage
              ? MOVO_COLOR
              : primaryColor,
            backgroundColor: !!this.props.order.isGreenPackage
              ? MOVO_COLOR
              : primaryColor,
            borderRadius: '100%',
            maxWidth: '6rem',
            maxHeight: '6rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ImageDispatcher
            alt="Icona carrello"
            src="/static/images/checkout_icon.png"
            style={{
              maxWidth: '40px',
              maxHeight: '40px',
            }}
          />
        </div>

        {this.props.location.query.payment_link ? (
          <div>
            <h1 className="title">Congratulazioni!</h1>

            <div className="paymentInstruction">
              <div
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 500,
                  lineHeight: '1.2',
                  marginBottom: '0.5rem',
                }}
              >
                Il tuo ordine è stato preso in carico. Riceverai una mail di
                conferma dell'ordine!
              </div>
              <p>
                <span style={{ color: '#999' }}>NUMERO ORDINE:</span> #
                {this.props.order.id}
              </p>
            </div>
            <div>{this.itemsDetails()}</div>
          </div>
        ) : (
          <div className="body-container">
            {!!this.props.order.isGreenPackage ? (
              <div>
                <h1 className="title" style={{ color: '#05668d' }}>
                  Grazie, ogni scelta conta!!
                </h1>
                <ImageDispatcher
                  style={{ marginBottom: '1rem', width: 100 }}
                  src="/static/images/movo_logo.png"
                />
              </div>
            ) : (
              <h1>Congratulazioni!</h1>
            )}

            <div className="paymentInstruction">
              <div
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 500,
                  lineHeight: '1.2',
                  marginBottom: '0.5rem',
                }}
              >
                Il tuo ordine è stato preso in carico. Riceverai una mail di
                conferma dell'ordine!
              </div>
              <p>
                <span style={{ color: '#999' }}>NUMERO ORDINE:</span> #
                {this.props.order.id}
              </p>
            </div>
            <div>{this.itemsDetails()}</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  storeId: state.store.data.storeId,
  siteName: state.store.data.datiFarmacia.siteName,
  checkout: state.checkout,
  glsShipping: state.store.data.glsShipping,
  costiSpedizione: state.store.data.costiSpedizione,
  bankName: state.store.data.datiFarmacia.bankName,
  bankAccount: state.store.data.datiFarmacia.bankAccount,
  trovaprezziId: state.store.data.integrazioni.trovaprezzi.id,
  email: state.user.data.email,
  order: state.singleOrder.data,
  advancedGa: state.store.data.features.advancedGa,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
  hasCriteo: state.store.data.features.hasCriteo,
  hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
  hasTrovaprezziTrustedProgram:
    state.store.data.features.hasTrovaprezziTrustedProgram,
  criteoAccountId: state.store.data.integrazioni.criteo.accountId,
  kelkooMerchantId: state.store.data.integrazioni.kelkoo.merchantId,
  hasKelkoo: state.store.data.features.hasKelkoo,
  hasTradeTracker: state.store.data.features.hasTradeTracker,
  tradeTracker: state.store.data.integrazioni.tradeTracker,
  hasTradedoubler: state.store.data.features.hasTradedoubler,
  tradedoubler: state.store.data.integrazioni.tradedoubler,
  hasIubendaCookieSolution: state.store.data.features.hasIubendaCookieSolution,
  hasGoogleAnalytics4Advanced: !!state.store.data.features
    .hasGoogleAnalytics4Advanced,
  hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
  hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  gAdsTrackingId: state.store.data.integrazioni.google.gAdsTrackingId,
  gAdsGoalId: state.store.data.integrazioni.google.gAdsGoalId,
  hasGoogleAdsTag: state.store.data.features.hasGoogleAdsTag,
  orders: state.orders.data.items,
});

export default connect(mapStateToProps, {
  loadOrder,
  emptyCart,
  loadCart,
  resetCheckout,
  loadOrders,
})(CheckoutSuccess);
